import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {RouletteMainResponseVo} from '../../common/shared/api/nicolas/vo/RouletteMainResponseVo.interface';

/**
 * 룰렛 정보 조회 (v2)
 *
 * :: 참고 ::
 *  API url 이 gotcha 라서 원래는 Gotcha 로 시작해야 하지만, gotcha-old 가 gotcha 이름을 사용중이라
 *  최신 버전의 gotcha 를 roulette 으로 사용해서 지금과 같은 이름으로 작성됐습니다.
 *
 * Origin: pageNicolasApi.getRouletteInfo
 * API: POST /api/v2/gotcha
 */
export async function postRouletteGet(
  {
    rouletteId,
    rouletteAdLocId,
  }: {
    rouletteId: string;
    rouletteAdLocId?: string;
  },
  options?: FetcherOptions
): Promise<
  ApiResultVo & {gotcha_id: string; gotcha_info: RouletteMainResponseVo}
> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v2/gotcha',
    {
      method: 'POST',
      data: {
        gotcha_id: rouletteId,
        ad_loc_id: rouletteAdLocId,
      },
    },
    options
  );
  return response.data;
}
